import { render, staticRenderFns } from "./LibrariaKolegjit.vue?vue&type=template&id=51800426&scoped=true"
import script from "./LibrariaKolegjit.vue?vue&type=script&lang=js"
export * from "./LibrariaKolegjit.vue?vue&type=script&lang=js"
import style0 from "./LibrariaKolegjit.vue?vue&type=style&index=0&id=51800426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51800426",
  null
  
)

export default component.exports